import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDeleteHiringPhase } from 'modules/ats/hooks/hiringStages/useDeleteHiringPhase'

interface Props {
  onClose: () => void
  currentPhaseId: string
}

export const DeletePhaseModal = ({ onClose, currentPhaseId }: Props) => {
  const { deleteAtsHiringPhase, loading } = useDeleteHiringPhase()

  const onDelete = async () => {
    const result = await deleteAtsHiringPhase({ id: currentPhaseId })

    const handled = handleResult(result, (_errors) => {
      // TODO remove it when handle result does not need error functions
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
      onClose()
    }
  }

  return (
    <Modal
      title={i18n.t('ats.hiring_pipelines.settings.sidepanel.delete_phase_modal.title')}
      description={i18n.t('ats.hiring_pipelines.settings.sidepanel.delete_phase_modal.description')}
      illustration="delete"
      onClose={onClose}
      onSubmit={onDelete}
      footer={
        <Box flexDirection="row" gap="s16">
          <Button type="secondary" onClick={() => onClose()}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={loading} type="negative" submit>
            {i18n.t('common.delete')}
          </Button>
        </Box>
      }
    ></Modal>
  )
}
